import styled from "styled-components";

import { SPACING } from "../../../../../utils/constants";

export const FootNote = styled.p`
  margin: ${SPACING.md}px 0 0;
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-base);
  line-height: 1.5;
  color: var(--color-text-secondary);

  strong {
    color: var(--color-text-default);
  }
`;
